import { render, staticRenderFns } from "./QuoteRFQFormDialog.vue?vue&type=template&id=21fba720&"
import script from "./QuoteRFQFormDialog.vue?vue&type=script&lang=ts&"
export * from "./QuoteRFQFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports